<template>
  <v-row style="width: 100%">
    <CalcBankInfoDialog :editedItemBank="bankViewData" style="position: absolute" />
    <CalcRateInfoDialog :editedItemProduct="rateViewData" :item="rateViewDataDop" style="position: absolute" />
    <AttentionWindow :calc="calc" :msg="msg" :vid="vid" style="position: absolute" />
    <v-card style="width: 100%">
      <!-- <h2 class="text-center colorblue">
        Предварительный расчет банковской гарантии
      </h2> -->
      <CalcResultParams @CloseDialog="CloseDialog" :calc="calc" />

      <v-divider></v-divider>
      <v-card-title>
        <div class="row no-gutters" style="padding: 10px 0; height: 80px">
          <div class="col-md-6 col-xs-12" style="display: flex; column-gap: 10px; align-items: center"
            @click="setClipboard($store.getters.getCalcRegisterId)">
            <v-btn @click="setFilter" style="min-width: 40px; width: 40px; height: 40px"
              :color="filter ? 'error' : 'transparent'">
              <v-icon size="20">fa-filter</v-icon>
            </v-btn>
            <div class="colorblue">
              Предложения банков по заданным параметрам {{ getKolPodhodit1 }}
              <v-tooltip right max-width="850">
                <template v-slot:activator="{ on }">
                  <v-icon right small v-on="on" style="margin: 0">info</v-icon>
                </template>
                <div>ID Расчета: {{ $store.getters.getCalcRegisterId }}</div>
              </v-tooltip>
            </div>
          </div>
          <div class="col-md-6 col-xs-12 text-right" style="display: flex; align-items: center; justify-content: end">
            <yearProcentComponent v-model="yearProcent" @change="changeYearProcent" />
          </div>
        </div>
      </v-card-title>
      <v-card-text>
        <v-data-table v-model="selected1" :sort-by="sortby" :headers="headersPodhodit" :items="getPodhodit1"
          item-key="product_id" :disable-pagination="true" :hide-default-footer="true" show-select class="elevation-1">
          <template v-slot:item.bank="{ item }">
            <BankInfo :item="item" @dialog="setDialog" @setBankViewData="setBankViewData"
              @setRateViewData="() => setRateViewData(item)" />
          </template>

          <template v-slot:item.agentConditions="{ item }">
            <div style="display: flex; padding: 5px 0">
              <AgentConditions :item="item" />
              <AgentConditionsTooltip :item="item" @dialog="setDialog" />
            </div>
          </template>

          <template v-slot:item.ikom="{ item }">
            <Ikom :item="item" :calc="calc" @dialog="setDialog" :yearProcent="yearProcent" />
          </template>

          <template v-slot:item.ikomsk="{ item }">
            <Ikomsk :item="item" :calc="calc" @dialog="setDialog" :yearProcent="yearProcent" />
          </template>

          <template v-slot:item.ikomClient="{ item }">
            <IkomClient :item="item" :calc="calc" @dialog="setDialog" :yearProcent="yearProcent" />
          </template>

          <template v-if="getClientSituation() !== '-'" v-slot:item.situation="{ item }">
            <Situation :item="item" @dialog="setDialog" />
          </template>

          <template v-slot:item.rate="{ item }">
            <SiteRate :item="item" />
          </template>
        </v-data-table>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-title>
        <div class="colorblue">
          Индивидуальные предложения {{ getKolPodhodit2 }}
        </div>
      </v-card-title>
      <v-card-text>
        <v-data-table v-model="selected2" :headers="headersPodhodit" :items="getPodhodit2" item-key="product_id"
          show-select :disable-pagination="true" :hide-default-footer="true" class="elevation-1">
          <template v-slot:item.bank="{ item }">
            <BankInfo :item="item" @dialog="setDialog" @setBankViewData="setBankViewData"
              @setRateViewData="() => setRateViewData(item)" />
          </template>
          <template v-slot:item.agentConditions="{ item }">
            <div style="display: flex; padding: 5px 0">
              <AgentConditions :item="item" />
              <AgentConditionsTooltip :item="item" @dialog="setDialog" />
            </div>
          </template>
          <!-- <template v-slot:item.ikomsk="{ item }">
            <span>{{ item.ikomsk == "0" ? 'индивидуально' : item.ikomsk }}</span>
          </template> -->
          <template v-slot:item.ikom="{ item }">
            <Ikom :item="item" :calc="calc" @dialog="setDialog" :yearProcent="yearProcent" />
          </template>
          <template v-slot:item.ikomClient="{ item }">
            <IkomClient :item="item" :calc="calc" @dialog="setDialog" :yearProcent="yearProcent" :procentShow="false" />
          </template>
          <template v-if="getClientSituation() !== '-'" v-slot:item.situation="{ item }">
            <Situation :item="item" @dialog="setDialog" />
          </template>
          <template v-slot:item.rate="{ item }">
            <SiteRate :item="item" />
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-text>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div class="colorblue">
                Предложения не соответствующие заданным параметрам
                {{ getKolNePodhodit2 }}
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-data-table :headers="headersNePodhodit" :items="getnepodhoditItems" item-key="product_id"
                class="elevation-1">
                <template v-slot:item.bank="{ item }">{{ item.bank }}&nbsp; {{ item.product }}</template>
              </v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
      <v-card-actions class="pl-5 pr-5">
        <v-btn @click.stop="AttentionWindowForSelected">Скачать расчет по выбранным банкам в xlsx</v-btn>
        <v-divider></v-divider>
        <v-btn @click.stop="AttentionWindowForAll">Скачать расчет по всем банкам в xlsx</v-btn>
        <v-divider></v-divider>
        <v-btn color="green" @click.stop="newCalculation">Новый расчет</v-btn>
      </v-card-actions>
      <v-dialog v-model="dialog" max-width="800px" @click:outside="() => close(false)">
        <v-card>
          <v-toolbar>
            <v-btn icon @click="() => close(false)">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title v-html="dialogTitle" class="dialog-title" />
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text v-html="dialogText" style="padding: 20px" />
        </v-card>
      </v-dialog>
    </v-card>
  </v-row>
</template>

<script>
import Swal from "sweetalert2";
import CalcBankInfoDialog from "./CalcBankInfoDialog.vue";
import CalcRateInfoDialog from "./CalcRateInfoDialog.vue";
import CalcResultParams from "./CalcResultParams.vue";
import AttentionWindow from "./AttentionWindow.vue";
import yearProcentComponent from "@/components/yearProcent.vue";

import { roleObj } from "@/plugins/roles";
import AgentConditions from "@/components/calcResult/agentConditions.vue";
import AgentConditionsTooltip from "@/components/calcResult/agentConditionsTooltip.vue";
import BankInfo from "@/components/calcResult/BankInfo.vue";
import Ikom from "@/components/calcResult/Ikom.vue";
import Ikomsk from "@/components/calcResult/Ikomsk.vue";
import IkomClient from "@/components/calcResult/IkomClient.vue";
import SiteRate from "@/components/calcResult/SiteRate.vue";
import Situation from "@/components/calcResult/Situation.vue";

export default {
  components: {
    CalcBankInfoDialog,
    CalcRateInfoDialog,
    AttentionWindow,
    yearProcentComponent,

    CalcResultParams,
    AgentConditions,
    AgentConditionsTooltip,
    BankInfo,
    Ikom,
    Ikomsk,
    IkomClient,
    SiteRate,
    Situation,
  },
  computed: {
    filter: {
      get() {
        return this.$store.getters.filter;
      },
      set(val) {
        this.$store.dispatch("setFilter", val);
      },
    },
    vid: {
      get() {
        return this.$store.getters.getVID;
      },
      set(val) {
        this.$store.commit("setVID", val);
      },
    },
    headersPodhodit() {
      if (this.getClientSituation() !== "-") {
        return [
          {
            text: "Банк",
            value: "bank",
            width: "30%",
            class: "nazv_bank",
            sortable: false,
          },
          {
            text: "Условия для агентов",
            value: "agentConditions",
            width: "210px",
            sortable: false,
            center: true,
          },
          {
            text: "Стандартная комиссия",
            value: "ikom",
            width: "130px",
            sortable: true,
          },
          {
            text: "Комиссия без снижения АВ",
            value: "ikomsk",
            width: "130px",
            sortable: true,
          },
          {
            text: "Комиссия для клиента",
            value: "ikomClient",
            width: "130px",
            sortable: true,
          },
          {
            text: "Особенности выдачи",
            value: "situation",
            width: "130px",
            sortable: true,
          },
          {
            text: "Сайт и рейтинг",
            value: "rate",
            width: "230px",
            sortable: false,
            center: true,
          },
        ];
      } else {
        return [
          {
            text: "Банк",
            value: "bank",
            width: "30%",
            class: "nazv_bank",
            sortable: false,
          },

          {
            text: "Условия для агентов",
            value: "agentConditions",
            width: "210px",
            sortable: false,
            center: true,
          },
          {
            text: "Стандартная комиссия",
            value: "ikom",
            width: "130px",
            sortable: true,
          },
          {
            text: "Комиссия без снижения АВ",
            value: "ikomsk",
            width: "130px",
            sortable: true,
          },
          {
            text: "Комиссия для клиента",
            value: "ikomClient",
            width: "130px",
            sortable: true,
          },
          {
            text: "Сайт и рейтинг",
            value: "rate",
            width: "230px",
            sortable: false,
            center: true,
          },
        ];
      }
    },
    calc() {
      return this.$store.getters.calc;
    },
    dialogMain() {
      return this.$store.getters.getResultDialog;
    },

    // getGarPolzZak() {
    //   const gar_polz_zak = this.$store.getters.calc.gar_polz_zaksVal;
    //   if (!gar_polz_zak) return "-";
    //   return gar_polz_zak.name;
    // },

    getPodhodit1() {
      return this.$store.getters.getPodhodit1;
    },
    getPodhodit2() {
      return this.$store.getters.getPodhodit2;
    },
    getKolPodhodit1() {
      if (this.$store.getters.getPodhodit1)
        return this.$store.getters.getPodhodit1.length;
      else return 0;
    },
    getKolPodhodit2() {
      return this.$store.getters.getPodhodit2.length;
    },
    getKolNePodhodit2() {
      return this.$store.getters.getNePodhodit.length;
    },
    getnepodhoditItems() {
      return this.$store.getters.getNePodhodit;
    },
    selected1: {
      get() {
        return this.$store.getters.get_selected1;
      },
      set(val) {
        this.$store.dispatch("SET_SELECTED1", val);
      },
    },
    selected2: {
      get() {
        return this.$store.getters.get_selected2;
      },
      set(val) {
        this.$store.dispatch("SET_SELECTED2", val);
      },
    },
  },
  filters: {
    toIndividual: function (value) {
      if (value == 0 || value == "0") return "индивидуально";
      return value;
    },
    toBool(val) {
      if (val) return "ДА";
      else return "Нет";
    },
  },
  async mounted() {
    this.setTitle(`Предварительный расчет банковской гарантии`);
    //
    // window.history.replaceState([],'',undefined)
    // calcreport
    await this.checkBanksLogo();
    // await this.$store.dispatch("addProductCS"); // для филтра

    if (this.$route.query.calcRegisterId) {
      const item = {
        _id: this.$route.query.calcRegisterId,
        table: true,
      };
      await this.sendToCalcResult(item);
    }

    await this.$store.dispatch("GET_RATING_CONFIG");
    if (
      this.$store.getters.calc.summ === "" ||
      this.$store.getters.calc.summ === null
    ) {
      this.$router.push("/calcagent");
    } else {
      await this.changeYearProcent();
    }
  },
  data() {
    return {
      roleObj,
      sortby: ["ikom"],
      dialog: false,
      dialogText: "",
      dialogTitle: "",
      bankViewData: null,
      rateViewData: null,
      rateViewDataDop: null,
      snack: false,
      snackColor: "",
      snackText: "",
      show: false,
      msg: "",
      notifications: false,
      sound: true,
      widgets: false,
      yearProcent: true,
      headersNePodhodit: [
        { text: "Название банка / продукт", value: "bank" },
        { text: "Причина несоответствия параметров продукту", value: "reason" },
      ],
      editParams: false,
    };
  },
  beforeDestroy() {
    if (this.editParams === false) {
      this.filter = false;
      this.$store.dispatch("setNewCalculation");
      this.$store.dispatch("clearResults");
      this.$store.dispatch("CLEAR_PROTOCOL_INFO");
      this.$store.commit("setProtocolInfoShowed", false);
      this.initDates();
      this.loading = false;
    }
  },
  methods: {
    setBankViewData() {
      this.bankViewData = this.$store.getters.getbankViewData;
    },
    setRateViewData(item) {
      this.rateViewData = this.$store.getters.getrateViewData;
      this.rateViewDataDop = item;
    },
    setDialog(evt) {
      this.dialog = evt.dialog;
      this.dialogTitle = evt.dialogTitle;
      this.dialogText = evt.dialogText;
    },
    setFilter() {
      this.filter = !this.filter;
    },
    close(val) {
      this.dialog = val;
      this.dialogText = "";
    },

    setClipboard(val) {
      navigator.clipboard.writeText(val);
    },
    async checkBanksLogo() {
      const logos = this.$store.getters.getBanksLogos;
      !logos.length && (await this.$store.dispatch("GET_BANKS_LOGOS"));
    },

    async changeYearProcent() {
      await this.$store.dispatch("SET_CALC_PARAM", {
        param: "yearProcent",
        value: this.yearProcent,
      });
    },

    newCalculation() {
      this.$store.dispatch("setNewCalculation").then(() => {
        this.$store.dispatch("SET_SELECTED1", []);
        this.$store.dispatch("SET_SELECTED2", []);
        this.$router.push("/calcagent");
      });
      // .catch((error) => {
      //   this.$router.push("/logout");
      //   Swal.fire({
      //     icon: "error",
      //     title: "Сеанс пользователя завершен. ",
      //     text: "Время Вашей сессии истекло, для продолжения работы войдите в личный кабинет заново",
      //   });
      // });
    },
    AttentionWindowForSelected() {
      if (
        !this.$store.getters.get_selected1.length &&
        !this.$store.getters.get_selected2.length
      ) {
        Swal.fire({
          icon: "warning",
          title: "Внимание!",
          text: "Не выбран ни один банк.",
        });
        return;
      }

      this.vid = 1;
      this.msg =
        "Для формирования xls по выбранным банкам нужно заполнить следующие поля:";
      this.$store.dispatch("setAttentionDIalog", true).then(() => { });
    },
    AttentionWindowForAll() {
      this.vid = 2;
      this.msg =
        "Для формирования xls по всем банкам нужно заполнить следующие поля:";

      this.$store.dispatch("setAttentionDIalog", true).then(() => { });
    },
    // SendOrders() {
    //   this.vid = 3;
    //   this.msg =
    //     "Для формирования заявки в банк нужно заполнить следующие поля:";
    //   this.$store.dispatch("setAttentionDIalog", true).then(() => {});
    // },
    CloseDialog() {
      this.editParams = true;
      this.genSession();
      this.$store.dispatch("clearResults").then(() => {
        this.$router.push("/calcagent");
      });
      this.$store.dispatch("setFilter", false);
    },
  },
};
</script>

<style lang="scss">
.dialog-title {
  display: flex;
  align-items: center;

  p {
    margin-bottom: 0 !important;
  }
}

.procent {
  color: #217899;
  font-size: 0.8em;
}

.v-subheader.text-blue.theme--light {
  color: #217899;
}

.text18 {
  font-size: 18px;
}

.paramsTable {
  max-width: 800px;
}

.text-center {
  text-align: center;
}

.colorblue {
  color: #217899;
}

.colorred {
  color: #bd1c32;
}

.theme--light.filledColor.v-input:not(.v-input--is-disabled) input {
  color: #217899;
}

.borderedStyle {
  border: 1px;
  border-style: solid;
}

.calcParam {
  .v-data-table td {
    font-size: 14px;
    height: 35px;
  }

  .selects {
    margin-top: 0;
    padding-top: 0;
    margin-bottom: 0;
    padding-bottom: 0;
  }

  .v-messages {
    min-height: 0;
  }
}

.centertop {
  padding-top: 35px;
}

.blackclass {
  color: powderblue;
}

.v-input.colorblue {
  color: #217899;
}

#app {

  .theme--light.v-input:not(.v-input--is-disabled) input,
  .theme--light.v-input:not(.v-input--is-disabled) textarea {
    color: #217899;
  }

  h1 {
    font-size: 1.5rem;
  }

  .bluelink {
    color: #217899;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .v-data-table-header tr th {
    padding: 5px;
  }

  .v-data-table-header tr th:last-child span {
    display: block;
    text-align: center;
  }

  @media (min-width: 1380px) {
    .v-data-table-header tr th {
      font-size: 0.85rem;
    }

    .v-dialog table thead tr th {
      font-size: 0.85rem;
    }

    .v-data-table tbody td {
      font-size: 0.85rem;
    }

    .v-card__title {
      font-size: 1.175rem;
    }

    .bank_name {
      font-size: 0.95rem;
    }
  }

  @media (max-width: 1380px) {
    .v-data-table-header tr th {
      font-size: 0.7rem;
    }

    .v-dialog table thead tr th {
      font-size: 0.7rem;
    }

    .v-data-table tbody td {
      font-size: 0.7rem;
    }

    .v-card__title {
      font-size: 1.075rem;
    }

    .bank_name {
      font-size: 0.85rem;
    }
  }

  @media (min-width: 1900px) {
    .v-data-table-header tr th {
      font-size: 1rem;
    }

    .v-dialog table thead tr th {
      font-size: 1rem;
    }

    .v-data-table tbody td {
      font-size: 1rem;
    }

    .v-card__title {
      font-size: 1.2rem;
    }

    .bank_name {
      font-size: 1.1rem;
    }
  }
}
</style>
